import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataProtection } from '@aptsi-types';
import { environment } from '@env';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorHandlingService } from '../../shared/errorHandling/errorHandling.service';
import { API_ENDPOINTS } from '../../data-protection-api-endpoints';

export interface DataProtectionDashboardMetrics extends DataProtection {
  dataAssets?: number | null;
  mappedAssets?: number | null;
  verifiedProtection?: number | null;
  needsAttention?: number | null;
}

interface GetDataProtectionResponse {
  dataProtectionDashboard?: DataProtectionDashboardMetrics;
}

@Injectable({ providedIn: 'root' })
export class DataProtectionDashboardService {
  private readonly dataProtectionReportsUrl = environment.apiUrl;

  constructor(
    private readonly http: HttpClient,
    private readonly errorHandlingService: ErrorHandlingService,
  ) {}

  getDpDashboardData(): Observable<DataProtectionDashboardMetrics> {
    return this.http
      .post<DataProtectionDashboardMetrics | GetDataProtectionResponse>(
        `${this.dataProtectionReportsUrl}${API_ENDPOINTS.DASHBOARD.FETCH}`,
        {},
      )
      .pipe(
        map((response) => {
          const wrapped = response as GetDataProtectionResponse;
          // Support both the raw response shown in the API sample and the older wrapped shape.
          return (wrapped?.dataProtectionDashboard ?? response) as DataProtectionDashboardMetrics;
        }),
        catchError((error) => this.errorHandlingService.handleError(error)),
      );
  }
}
